module.exports = __webpack_public_path__ + "static/img/14-Oxford-PV.4f5aa767.jpg";